// See @DOCSAPP/EN/room-row-pricing-architecture for the §3 Client Primitives seam definition.
import type { PriceBreakdownContainer } from '@/EditReservation/types';

export function hasDiscounts(breakdown: PriceBreakdownContainer): boolean {
    return breakdown.Discounts.length > 0;
}

export function isOpenPrice(breakdown: PriceBreakdownContainer): boolean {
    return breakdown.BaseAmount.Source.startsWith('Open Price');
}

export function getBreakdownSourceLabel(breakdown: PriceBreakdownContainer): string {
    return breakdown.BaseAmount.Source;
}
